<script setup lang="ts">
import { useTemplateRef } from "vue";

import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";

const buttonRef = useTemplateRef("button");
defineExpose({ focus: () => void buttonRef.value?.focus() });
</script>

<template>
  <BaseButton
    ref="button"
    class="objective-btn"
    variant="ghost"
    color="primary"
    icon-before="system/plus"
    :aria-label="$t('label.objective.add')"
  >
    {{ $t("objectives.add") }}
  </BaseButton>
</template>
